export { default as PosTiers } from './posTiers.container';
